import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import './MarketSegments.css';

const MarketSegments = ({ title, items }) => {
  return (
    <section className="market-segments">
      <div className="market-segments__inner">
        <Reveal>
          <h2 className="market-segments__title">{title}</h2>
        </Reveal>

        <div className="market-segments__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 80}>
              <article className="market-segments__item">
                <div className="market-segments__icon">
                  <img src={icon} alt="" aria-hidden="true" />
                </div>
                <h3 className="market-segments__item-title">{itemTitle}</h3>
                <p className="market-segments__item-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketSegments;
